import { useEffect, useState } from 'react';
import { Control, FieldValues, useController, UseFormWatch } from 'react-hook-form';

const useCheckboxWithControl = (
  name: string,
  control: Control,
  defaultChecked?: boolean,
  onCheck?: (arg: React.ChangeEvent<HTMLInputElement>) => void,
  watch?: UseFormWatch<FieldValues>
) => {
  const [isChecked, isCheckedSet] = useState(false);

  const {
    field: { value },
  } = useController({ name, control });

  const permissions = watch && watch('permissions');

  useEffect(() => {
    if (!permissions) return;

    if (!permissions.includes(name)) {
      isCheckedSet(false);
    }
  }, [permissions]);

  useEffect(() => {
    if (!onCheck) {
      if (value !== undefined) {
        isCheckedSet(Boolean(value));
      } else if (typeof value === 'undefined' && defaultChecked !== undefined) {
        isCheckedSet(defaultChecked);
      }
    }
  }, [value, defaultChecked, onCheck]);

  useEffect(() => {
    if (defaultChecked !== undefined) {
      isCheckedSet(defaultChecked);
    }
  }, [defaultChecked]);

  return {
    isChecked,
    isCheckedSet,
  };
};

export { useCheckboxWithControl };
